import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { ISupplementListState } from '../../../../types/supplement/supplementsTypes';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import DotIcon from '../../../components/DotIcon';
import Tooltip from '../../../../muiComponents/Tooltip';
import Tag from '../../../../muiComponents/Tag';
import {
    categorizePeriod,
    formatDate,
    isDateless,
} from '../../../../utils/formatDates';
import routes from '../../../../utils/commonVariables/routes';
import { TAX_DATE_TAG_COLOR } from '../../../../utils/taxes/taxesListUtils';
import SupplierTaxCalculationTypeIcon from '../../taxes/taxTypesIcons/SupplierTaxCalculationTypeIcon';
import SupplierTaxCalculationRuleTypeIcon from '../../taxes/taxTypesIcons/SupplierTaxCalculationRuleTypeIcon';

interface SupplementRowProps {
    supplement: ISupplementListState;
}

const SupplementRow = ({ supplement }: SupplementRowProps) => {
    const { setSearchParam } = useSearchParams({ base64: true });
    const handleRowClick = (idTax: string) => {
        setSearchParam('id', idTax);
    };

    const datelessFrom = isDateless(supplement.FromDate);
    const datelessTo = isDateless(supplement.ToDate);

    const isDatelessSupplement = datelessFrom && datelessTo;
    const tagText = categorizePeriod(supplement.FromDate, supplement.ToDate);
    const linkToHotel = routes.propertyDetail(supplement.IdSupplierHotel);

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(supplement.Id)}
        >
            <TableCell>
                <div className='flex-center'>
                    <DotIcon truthy={supplement.Enabled} />
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <h6 className='text-secondary-700 text-size-14'>
                    {supplement.Name}
                </h6>

                <Tooltip title={supplement.Description || ''}>
                    <p className='tax__description text-preline'>
                        {supplement.Description || ''}
                    </p>
                </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <Tooltip titleText='navigate_to_hotel_detail'>
                    <h6
                        className='tax__title link-onhover'
                        onClick={e => {
                            e.stopPropagation();
                            window.open(linkToHotel, linkToHotel);
                        }}
                    >
                        {supplement.SupplierHotel}
                    </h6>
                </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {supplement.SupplierHotelRoomType}
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {supplement.SupplierHotelMealPlan}
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {supplement.SupplierHotelRatePlan}
            </TableCell>
            <TableCell>
                <div className='flex gap-10'>
                    <SupplierTaxCalculationTypeIcon
                        entityKey={supplement.SupplierTaxCalculationTypeKey}
                        text={supplement.SupplierTaxCalculationType}
                    />
                    <SupplierTaxCalculationRuleTypeIcon
                        entityKey={supplement.SupplierTaxCalculationRuleTypeKey}
                        type='subject'
                    />
                    <SupplierTaxCalculationRuleTypeIcon
                        entityKey={supplement.SupplierTaxCalculationRuleTypeKey}
                        type='frequency'
                    />
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                {!isDatelessSupplement ? (
                    <div className='flex-column flex-align-end gap-10 height100perc flex-between'>
                        {formatDate(supplement.FromDate)} -{' '}
                        {formatDate(supplement.ToDate)}
                        <Tag
                            text={tagText}
                            color={TAX_DATE_TAG_COLOR[tagText]}
                        />
                    </div>
                ) : (
                    ''
                )}
            </TableCell>
        </TableRow>
    );
};

export default SupplementRow;
